import {createSlice} from '@reduxjs/toolkit';

export interface NavState {
    selectedPageIndex: number,
}

const initialState: NavState = {
    selectedPageIndex: -1,
}

export const navSlice = createSlice({
    name: 'nav',
    initialState,
    reducers: {
        setSelectedPageIndex(state, action){
            state.selectedPageIndex = action.payload;
        },
        clearSelectedPageIndex(state){
            state.selectedPageIndex = -1;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setSelectedPageIndex, clearSelectedPageIndex } = navSlice.actions

export default navSlice.reducer